/**
 * 最近見た商品 (GRAPHIQUE NOIR)
 * - 商品ページで handle を localStorage に保存 (最新 12 件)
 * - Section Rendering API で /search を叩き、サーバー側で描画した card-product を差し込む
 */
(() => {
  const STORAGE_KEY = 'gn_recently_viewed';
  const MAX_STORED = 12;

  const readHandles = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter((h) => typeof h === 'string') : [];
    } catch (error) {
      console.warn('[gn-recently-viewed] localStorage read failed', error);
      return [];
    }
  };

  const writeHandles = (handles) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (error) {
      console.warn('[gn-recently-viewed] localStorage write failed', error);
    }
  };

  class GnRecentlyViewed extends HTMLElement {
    connectedCallback() {
      const current = this.dataset.current;
      let handles = readHandles();

      if (current) {
        handles = [current, ...handles.filter((h) => h !== current)];
        writeHandles(handles);
        handles = handles.filter((h) => h !== current);
      }

      const max = Number(this.dataset.max) || 5;
      const toShow = handles.slice(0, max);
      if (toShow.length === 0) return;

      const query = toShow.map((h) => `handle:${h}`).join(' OR ');
      const url = `${window.routes?.search_url || '/search'}?section_id=${encodeURIComponent(this.dataset.sectionId)}&type=product&options[prefix]=none&q=${encodeURIComponent(query)}`;

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);

      fetch(url, { signal: controller.signal })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = doc.querySelector('[data-gn-rv-grid]');
          if (!grid) return;
          // 閲覧順に並べ替え (検索結果の順序は保証されないため)
          const items = Array.from(grid.querySelectorAll('[data-handle]'));
          const order = new Map(toShow.map((h, i) => [h, i]));
          items.sort((a, b) => (order.get(a.dataset.handle) ?? 99) - (order.get(b.dataset.handle) ?? 99));
          items.forEach((li) => grid.appendChild(li));
          const wrapper = grid.closest('.gradient') || grid;
          this.replaceChildren(wrapper);
        })
        .catch((error) => {
          console.warn('[gn-recently-viewed] fetch failed', error);
        })
        .finally(() => clearTimeout(timer));
    }
  }

  if (!customElements.get('gn-recently-viewed')) {
    customElements.define('gn-recently-viewed', GnRecentlyViewed);
  }
})();
